import { render, staticRenderFns } from "./CommunityModelGrid.vue?vue&type=template&id=3aab10ad&scoped=true"
import script from "./CommunityModelGrid.vue?vue&type=script&lang=js"
export * from "./CommunityModelGrid.vue?vue&type=script&lang=js"
import style0 from "./CommunityModelGrid.vue?vue&type=style&index=0&id=3aab10ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aab10ad",
  null
  
)

export default component.exports